function Icon({ name }) {
  switch (name) {
    case "home":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 11.5 12 4l9 7.5V20a1 1 0 0 1-1 1h-5v-5H9v5H4a1 1 0 0 1-1-1z" fill="currentColor" />
        </svg>
      );
    case "box":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5z" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="m4 7.5 8 4.5 8-4.5M12 12v9" stroke="currentColor" strokeWidth="1.6" fill="none" />
        </svg>
      );
    case "tag":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M4 5h7.5l7.5 7.5-7.5 7.5L4 12.5z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="9" cy="9" r="1.2" fill="currentColor" />
        </svg>
      );
    case "file":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 3h7l5 5v13H7z" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M14 3v6h5" stroke="currentColor" strokeWidth="1.6" fill="none" />
        </svg>
      );
    case "store":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 9h16l-1-4H5z" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M6 9v10h12V9" stroke="currentColor" strokeWidth="1.6" fill="none" />
          <path d="M9 15h6" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      );
    case "users":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="9" cy="8" r="3.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M3.5 19c.6-3.1 3-5 5.5-5s5 1.9 5.5 5" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M17.5 12.8a2.8 2.8 0 1 0-1.8-5.2M16.5 13.3c1.8 0 3.6 1.2 4 3.4" stroke="currentColor" strokeWidth="1.4" fill="none" />
        </svg>
      );
    case "chart":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 19h16" stroke="currentColor" strokeWidth="1.6" />
          <path d="M7 19v-6M12 19V7M17 19v-9" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    );
    case "settings":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.573-1.065z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "bell":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M5 17h14l-1.5-2.5a5.5 5.5 0 0 1-.7-2.7V9a5 5 0 1 0-10 0v2.8c0 .9-.2 1.8-.7 2.7z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          />
          <path d="M10 19a2 2 0 0 0 4 0" stroke="currentColor" strokeWidth="1.6" fill="none" />
        </svg>
      );
    case "report":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="5" y="3" width="14" height="18" rx="2" ry="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      );
    case "addSquare":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3.5" y="3.5" width="17" height="17" rx="4" ry="4" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M12 8v8M8 12h8" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      );
    case "import":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 14v4h12v-4" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="m8.5 10 3.5 4 3.5-4M12 4v10" stroke="currentColor" strokeWidth="1.6" fill="none" />
        </svg>
      );
    case "barcode":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 6v12M8 8v8M11 6v12M13 8v8M16 6v12M19 8v8" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      );
    case "invoice":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 3h10l0 18H7z" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M9.5 8H15M9.5 11.5H15" stroke="currentColor" strokeWidth="1.4" />
          <path d="M9.5 15H12" stroke="currentColor" strokeWidth="1.4" />
          <path d="M7 6h10" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      );
    case "userAdd":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="11" cy="8" r="3.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M5.5 19c.6-3.1 3-5 5.5-5s5 1.9 5.5 5" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M17.5 8v4M15.5 10h4" stroke="currentColor" strokeWidth="1.6" />
        </svg>
      );
    case "doc":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7 3h7l5 5v13H7z" fill="none" stroke="currentColor" strokeWidth="1.6" />
          <path d="M14 3v6h5" stroke="currentColor" strokeWidth="1.6" fill="none" />
          <path d="M9 13h6M9 16h6" stroke="currentColor" strokeWidth="1.4" />
        </svg>
      );
    case "upload":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 16v2h12v-2" stroke="currentColor" strokeWidth="1.6" fill="none" />
          <path d="m8.5 12 3.5-4 3.5 4M12 8v8" stroke="currentColor" strokeWidth="1.6" fill="none" />
        </svg>
      );
    case "menu":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "close":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    case "chevronDown":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
      );
    case "chevronRight":
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
      );
    default:
      return null;
  }
}

export default Icon;
